import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    CircularProgress
} from '@mui/material';

const OrderNotesDialog = ({ 
    open, 
    onClose, 
    onSave, 
    selectedOrder,
    loading = false 
}) => {
    const [notes, setNotes] = useState('');
    const [diners, setDiners] = useState('');

    useEffect(() => {
        if (selectedOrder && open) {
            setNotes(selectedOrder.notes || '');
            setDiners(selectedOrder.dinners || '');
        }
    }, [selectedOrder, open]);

    const handleSave = () => {
        onSave({
            notes: notes,
            dinners: parseInt(diners) || 0
        });
    };

    const handleCancel = () => {
        // Reset to original values
        setNotes(selectedOrder?.notes || '');
        setDiners(selectedOrder?.dinners || '');
        onClose();
    };

    const isValidForm = () => {
        return diners === '' || (!isNaN(parseInt(diners)) && parseInt(diners) >= 0);
    };

    return (
        <Dialog 
            open={open} 
            onClose={loading ? undefined : handleCancel}
            maxWidth="sm" 
            fullWidth
        >
            <DialogTitle>Edit Order Details</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
                    <TextField
                        label="Order Notes"
                        multiline
                        rows={4}
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        placeholder="Add any special instructions or notes for this order..."
                        fullWidth
                        disabled={loading}
                    />
                    <TextField
                        label="Number of Diners"
                        type="number"
                        value={diners}
                        onChange={(e) => setDiners(e.target.value)}
                        placeholder="Enter number of diners"
                        fullWidth
                        disabled={loading}
                        inputProps={{ min: 0 }}
                        error={!isValidForm()}
                        helperText={!isValidForm() ? "Please enter a valid number of diners" : ""}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button 
                    onClick={handleCancel}
                    variant="outlined"
                    disabled={loading}
                >
                    Cancel
                </Button>
                <Button 
                    onClick={handleSave}
                    variant="contained"
                    color="primary"
                    disabled={loading || !isValidForm()}
                    startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
                >
                    {loading ? "Saving..." : "Save"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OrderNotesDialog; 